// w15.js
import React from 'react';
import WW from './ww';
import { pageConfigs } from '../../configs';

const W15 = () => {
  return <WW config={pageConfigs.w15} />;
};

export default W15;
